module.exports = __webpack_public_path__ + "img/salvador.1f2e7466.svg";